import React from 'react';

const Stories = () => {
    return (
        <div>
            <h1>Stories Page</h1>
            <p>Welcome to the profile page!</p>
        </div>
    );
};  

export default Stories;